import { render, staticRenderFns } from "./PromotionConditions.vue?vue&type=template&id=66a8a460&"
import script from "./PromotionConditions.vue?vue&type=script&lang=ts&"
export * from "./PromotionConditions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports